import PropTypes from 'prop-types'
import { map } from 'lodash'
import Link from 'components/link'
import { storePath } from 'lib/urls'
import OrderPanel from './order-panel'

const OrderList = ({ orders }) => {
  return (
    <div id="order-list">
      {orders.length === 0 ? (
        <p>
          {`You haven't placed any orders yet. Visit the `}
          <Link url={storePath} href={storePath}>
            Babylist shop
          </Link>
          {` to place an order.`}
        </p>
      ) : (
        map(orders, (order) => (
          <OrderPanel
            key={order.reference}
            cancelUntil={order.cancelUntil}
            className="mbxl"
            createdAt={order.createdAt}
            canCancel={order.canCancel}
            orderItems={order.orderItems}
            reference={order.reference}
            returnWebUrl={order.returnWebUrl}
            statusWebUrl={order.statusWebUrl}
            total={order.total}
            trackingInfos={order.trackingInfos}
            uuid={order.uuid}
          />
        ))
      )}
    </div>
  )
}

OrderList.defaultProps = {
  orders: [],
}

OrderList.propTypes = {
  orders: PropTypes.arrayOf(
    PropTypes.shape({
      cancelUntil: PropTypes.string,
      createdAt: PropTypes.string,
      canCancel: PropTypes.bool,
      orderItems: PropTypes.arrayOf(PropTypes.object),
      reference: PropTypes.string,
      returnWebUrl: PropTypes.string,
      statusWebUrl: PropTypes.string,
      total: PropTypes.number,
      trackingInfos: PropTypes.arrayOf(PropTypes.object),
      uuid: PropTypes.string,
    })
  ),
}

export default OrderList
